import { Component, Input, OnInit } from '@angular/core';
import { AslibModalComponent } from '@aslib/modal';

@Component({
  selector: 'sarf-modal-manager',
  templateUrl: './modal-manager.component.html',
  styleUrls: ['./modal-manager.component.scss']
})
export class ModalManagerComponent implements OnInit {

  @Input() public modal: AslibModalComponent;
  @Input() public error: any;

  constructor() {}

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal-manager/modal-manager.component.ts